import CloseIcon from '@mui/icons-material/Close';
import { DialogTitle, DialogTitleProps, IconButton, Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';
import React from 'react';
import Text from '../Text';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: theme.spacing(2)
    },
    closeButton: {}
}))


interface Props extends DialogTitleProps {
    hideCloseButton?: boolean;
    onClose?: ((event: {}, reason: "backdropClick" | "escapeKeyDown") => void) | undefined
    className?: string | undefined
}

const ModalTitle: React.FC<Props> = ({
    children,
    className,
    hideCloseButton = false,
    onClose,
    ...props
}) => {
    const classes = useStyles()

    const handleOnClick = (e: {}) => {
        if (onClose) onClose(e, "backdropClick")
    }

    return (
        <DialogTitle className={clsx(classes.root, className)} {...props}>
            <Text fontWeight={400} fontSize={16}>{children}</Text>
            {
                !hideCloseButton ?
                    <IconButton aria-label="close" className={classes.closeButton} color="inherit" onClick={handleOnClick}>
                        <CloseIcon />
                    </IconButton> : null
            }
        </DialogTitle>
    )
}

export default ModalTitle
